










































import { Vue, Prop, Component } from "vue-property-decorator";
import { CourseProgress as ICourseProgress } from "@/api/models/course-progress";
import ProgressDonut from "@/components/form/ProgressDonut.vue";
import { learningProgressPercent } from "@/plugins/learning-progress-percent";
import { practiceStatusFormatter } from "@/plugins/statuses";

@Component({
  components: { ProgressDonut }
})
export default class HomePageListenerCourseProgressItem extends Vue {
  @Prop() progress!: ICourseProgress;

  get practiceClass(): string {
    let practiceClass: string = "not_passedAt-link";

    if (this.progress.listener.course.practice) {
      practiceClass =
        this.progress.practice?.status === "passed"
          ? "passedAt-link"
          : "not_passedAt-link";
    }

    return practiceClass;
  }

  get practiceStatus(): string | undefined {
    return practiceStatusFormatter(this.progress.practice?.status);
  }

  get percentLearning(): number {
    return learningProgressPercent(this.progress);
  }

  get lectureInCourseCount(): number {
    return this.progress.listener.course.lecturesCount
      ? this.progress.listener.course.lecturesCount
      : 0;
  }

  get lectureReadCount(): number {
    return this.progress?.lectures?.length
      ? this.progress?.lectures?.filter(el => el.readAt).length
      : 0;
  }

  get isAllLectureRead(): boolean {
    return this.lectureReadCount === this.progress?.lectures?.length;
  }

  get testExist(): boolean {
    return !!this.progress.listener.course.test;
  }

  get testStatus(): string {
    return this.progress.test
      ? this.formatTestStatus(this.progress.test.success)
      : this.$tc(this.$translate.TheTestHasNotStarted);
  }

  get testClass(): string {
    let passedClass: string = "";

    if (this.testExist) {
      passedClass =
        this.progress.test?.success === true
          ? "passedAt-link"
          : "not_passedAt-link";
    }

    return passedClass;
  }

  formatTestStatus(value: boolean) {
    return value
      ? this.$tc(this.$translate.Successful)
      : this.$tc(this.$translate.NotStarted);
  }
}
